import * as React from 'react'
import { useState } from 'react'


const Context = React.createContext({})

export function CommonFiltersParityContextProvider({ defaultValues={}, children }) {

	const initialFilterState = {
		otas: [], metas: [], deviceParity: 1, info: null,
		...defaultValues
	}

	const [state, setState] = useState(initialFilterState)

	return <Context.Provider value={{state, setState, initialFilterState}}>
		{children}
	</Context.Provider>
}

export default Context